import { useCallback, useEffect, useState } from "react";
import HC from "@/lib/compute";
import { api } from "@/lib/api";
import { store, VALID_TABS } from "@/lib/ui";
import { Header } from "@/components/dash/Header";
import { Tip } from "@/components/dash/Tip";
import { Credit } from "@/components/dash/Credit";
import ProjectScore from "@/views/ProjectScore";
import ActivityResponses from "@/views/ActivityResponses";
import DataFolders from "@/views/DataFolders";
import SubmissionStatus from "@/views/SubmissionStatus";
import ScoringGuide from "@/views/ScoringGuide";

const hashTab = () => (window.location.hash || "").replace("#", "");
const initialTab = () => VALID_TABS.includes(hashTab()) ? hashTab() : (VALID_TABS.includes(store.get("tab", "")) ? store.get("tab") : "score");
const INIT = {
  fy: "", rid: "", p: "", tool: "", ind: "", intv: "",
  a_rid: "", a_p: "", a_q: "", a_limit: 120,
  l_fy: "", l_agency: "", s_rid: "", s_p: "", pf: ["", "", "", ""],
};
const VIEWS = { score: ProjectScore, activity: ActivityResponses, links: DataFolders, subs: SubmissionStatus, guide: ScoringGuide };

export default function Dashboard({ user, onLogout, onExpired, onNav }) {
  const [tab, setTab] = useState(initialTab);
  const [st, setSt] = useState(INIT);
  const [ready, setReady] = useState(false);
  const [meta, setMeta] = useState(null);
  const [err, setErr] = useState(null);
  const set = useCallback(patch => setSt(s => ({ ...s, ...patch })), []);

  useEffect(() => {
    api("/api/snapshot")
      .then(r => { if (r.status === 401) { onExpired(); return null; } if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(d => { if (!d) return; HC.init(d); setMeta(d.meta); setReady(true); })
      .catch(e => setErr(e.message));
  }, [onExpired]);
  useEffect(() => {
    const on = () => { const t = hashTab(); if (VALID_TABS.includes(t)) setTab(t); };
    window.addEventListener("hashchange", on);
    return () => window.removeEventListener("hashchange", on);
  }, []);
  const selectTab = t => { setTab(t); store.set("tab", t); try { window.history.replaceState(null, "", "#" + t); } catch (e) { } };

  const View = VIEWS[tab];
  return (
    <>
      <Header meta={meta} tab={tab} onTab={selectTab} user={user} onLogout={onLogout} onNav={onNav} />
      <main className="wrap" id="main" data-testid={`view-${tab}`}>
        {err ? <div className="loading">The data file did not load ({err}). Reload the page to try again.</div>
          : !ready ? <div className="loading">Loading assessment data…</div>
            : <View st={st} set={set} />}
      </main>
      <footer className="wrap" id="foot" hidden></footer>
      <Credit />
      <Tip hideKey={[tab, st]} />
    </>
  );
}
